export default "__VITE_ASSET__07c0c786__"